import { computed, ref } from 'vue';

export const useUploadFile = () => {
  const fileNamePlaceholder = 'Select file';
  const fileName = ref(fileNamePlaceholder);
  const base64BlobResult = ref('');
  const onFileChange = (event: any) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      base64BlobResult.value = typeof reader?.result === 'string' ? reader?.result?.split(',')[1] : '';
      fileName.value = file.name;
    };

    reader.readAsDataURL(file);
  };

  const isFileChosen = computed(() => !fileName.value || fileName.value !== fileNamePlaceholder);
  const fileContentBase64 = computed(() => base64BlobResult.value);
  return { fileContentBase64, fileName, isFileChosen, onFileChange };
};
